module.exports = __webpack_public_path__ + "static/media/limit-dark.2102a9b8.svg";